import script from "./SparePartsInventory.vue?vue&type=script&setup=true&lang=ts"
export * from "./SparePartsInventory.vue?vue&type=script&setup=true&lang=ts"

import "./SparePartsInventory.vue?vue&type=style&index=0&id=263bcbf7&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-263bcbf7"]])

export default __exports__